import { render, staticRenderFns } from "./Caratteristiche.vue?vue&type=template&id=0bf89974&scoped=true&"
import script from "./Caratteristiche.vue?vue&type=script&lang=js&"
export * from "./Caratteristiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf89974",
  null
  
)

export default component.exports